import { HeaderForm } from "../header-form"

interface FormSectionDividerProps {
  title: string
}

export function FormSectionDivider({ title }: FormSectionDividerProps) {
  return (
    <div className="flex items-center w-full">
      <HeaderForm title={title} />
    </div>
  )
}